module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"riot","commonjs2":"riot","amd":"riot","root":"riot"}
// module id = 2
// module chunks = 0